import { useCallback } from 'react';
import { BackHandler, Platform } from 'react-native';
import { useFocusEffect } from 'expo-router';

/**
 * Keep Android's system Back action aligned with the explicit header Back
 * button on detail routes. Header components can remain mounted while another
 * route is active, so this listener must be scoped to navigation focus rather
 * than component lifetime.
 */
export default function useAndroidDetailBack(router, destination) {
  useFocusEffect(
    useCallback(() => {
      if (Platform.OS !== 'android') return undefined;

      const subscription = BackHandler.addEventListener('hardwareBackPress', () => {
        router.replace(destination);
        return true;
      });

      return () => subscription.remove();
    }, [destination, router]),
  );
}
